import React, {  useState } from 'react'
import './Todos.css'
import { useDispatch, useSelector } from 'react-redux'
import { addTodos, clearCart, removeTodos, selectAllTodo } from './TodosSlice'
import { TimeAgo } from './TimeAgo'


const Todos = () => {
    const todos=useSelector(selectAllTodo)
    const[title,setTitle]=useState([])
    const dispatch=useDispatch()
    const onClickHandler=()=>{
        if(title){
                dispatch(addTodos(title))
                setTitle('')
        }
    }
    const onformHandle =(event)=>{
        event.defaultPrevent()
    }


   

  return (
    <div>

      
      <div className="container-fluid " style={{height:'5000px'}} >
        <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 m-auto " style={{height:'5000px'}} id="todos">
                
             <h1 className='text-center mt-3 mb-5'>ADD YOUR LIST HERE</h1>


                    {/* -------------------------------input form----------------------------------------------------------- */}
            <form action="" onSubmit={onformHandle}>
                <div className="hstack gap-3">
                    <input className="form-control me-auto   border border-0 rounded-0 " type="text" placeholder="🖊🖋 Add your item here..." aria-label="Add your item here..." id="postTitle" name='postTitle'  value={title}  onChange={(event)=>setTitle(event.target.value)}  style={{background:'#E6E6E6'}} autoComplete='off'  />
                    <div className="vr"></div>
                    <button type="button" className="btn btn-secondary"    onClick={onClickHandler} >
                    <span><i className="fa-sharp fa-solid fa-plus fs-5"></i></span>
                    </button>
                </div>
            </form>

                    {/* -----------------------------------------dispaly data---------------------------------- */}
            <div className='me-auto mt-3'>
            { 
                todos && todos.map((todo)=>{
                    return(
                        <div  key={todo.id} className='d-flex  gap-3 mt-2' >
                           <div className='vstack '>
                           <h4 className='me-auto  '  >  {todo.title} </h4>
                           <TimeAgo timestamp={todo.date}/>
                           </div>
                            <div >
                            <button type="button" className="btn btn-outline-danger mx-2 " onClick={()=>dispatch(removeTodos(todo.id))}>  <span><i className="fa-sharp fa-solid fa-trash"></i></span></button>
                            </div>
                        </div>
                    )
                })
            }
            </div>
                <div className="d-grid">
                    <button className="btn btn-secondary m-auto mt-5 col-md-4 fs-5" onClick={()=>dispatch(clearCart())}>Checklist</button>
                </div>
    
            </div>    
        </div>
      </div>
    </div>
  )
}

export default Todos